const baseKey = '/v1/device'

export const deviceAPI = {
  baseKey,
  create: `${baseKey}/create`,
  getMessages: (id: string) => `${baseKey}/${id}/messages`,
  getDevice: (id: string) => `${baseKey}/${id}`,
  updateName: `${baseKey}/update/name`,
  updateStatus: `${baseKey}/update/status`,
  deleteDevice: (id: string) => `${baseKey}/${id}`,
  enableDevice: (id: string) => `${baseKey}/enable/${id}`,
  disableDevice: (id: string) => `${baseKey}/disable/${id}`,
}
